import React, { FunctionComponent, useCallback, useEffect } from 'react';

import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme';

import { ModalConfirmPure } from '../../../../../../shared/components/modal-confirm';
import { i18n } from '../../../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../../../shared/helpers/metrika';
import { useActions } from '../../../../../../shared/hooks';
import { useSummarizationMailRecipientCheckboxState } from '../../hooks/use-summarization-mail-recipient-checkbox-state';
import { setIsSummarizationModalClosedAction } from '../../slice';
import { SummarizationModalProps } from '../../types';
import { SummarizationMailRecipientCheckbox } from '../summarization-mail-recipient-checkbox';

export const SummarizationStartModal: FunctionComponent<SummarizationModalProps> = () => {
    const { closeModal } = useActions({ closeModal: setIsSummarizationModalClosedAction });
    const [checkboxState, setCheckboxState] = useSummarizationMailRecipientCheckboxState();

    useEffect(() => countMetrika('meeting_screen', 'summarization', 'start_popup_was_shown'), []);

    const onConfirm = () =>
        closeModal({
            isConfirmed: true,
            isSummarizationMailForParticipants: checkboxState.isSelected,
        });
    const onClose = () => closeModal({ isConfirmed: false });

    const onCheckboxChange = useCallback(
        (isSelected: boolean) => {
            setCheckboxState({
                isSelected,
            });
        },
        [setCheckboxState]
    );

    return (
        <ScopedTheme theme="dark">
            <ModalConfirmPure
                visible={true}
                onClose={onClose}
                onCancel={onClose}
                onConfirm={onConfirm}
                title={i18n('summarization', 'start-dialog-title-v2')}
                cancelLabel={i18n('summarization', 'start-dialog-deny')}
                confirmLabel={i18n('summarization', 'start-dialog-submit')}
            >
                {i18n('summarization', 'start-dialog-content-v2')}
                <SummarizationMailRecipientCheckbox {...checkboxState} onChange={onCheckboxChange} />
            </ModalConfirmPure>
        </ScopedTheme>
    );
};
